// Copypasta from Glue OS
import React from 'react'
import { makeStyles, ButtonBase } from '@material-ui/core'
// import { hoverAudio, clickAudio } from './common-vuplex-messages'

const useStyles = makeStyles((theme) => ({
  root: (props) => ({
    ...theme.custom.glueButton[props.variant ?? 'main'],
    width: props.width ?? theme.custom.glueButton[props.variant ?? 'main'].width, // This is extremely dumb

    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',

    textTransform: props.textTransform ?? null,
    fontWeight: props.fontWeight ?? null,
    letterSpacing: props.letterSpacing ?? null,

    background: props.toggled ? theme.palette[props.color ?? 'secondary'].active : theme.palette[props.color ?? 'secondary'].main,
    color: props.toggled ? theme.palette[props.color ?? 'secondary'].textActive : theme.palette[props.color ?? 'secondary'].contrastText,

    '&:hover': {
      filter: 'brightness(1.25)'
    },

    '&:active': {
      filter: 'brightness(1.50)'
    },

    '&:disabled': {
      opacity: '50%'
    }
  }),

  textLabel: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
}), { name: 'MuiGlueButton' })

const filterChildren = (children, classes) => {
  const incoming = Array.isArray(children) ? children : [children]
  const accepted = []

  for (let i = 0; i < incoming.length; ++i) {
    const child = incoming[i]

    if (!child) {
      continue
    }

    if (typeof child === 'string') {
      // Plain text needs to be wrapped in an element so that 'text-overflow: ellipsis'
      // works reliably on all browsers in this flex context.

      accepted.push(<div key={i} className={classes.textLabel}>{child}</div>)
      continue
    }

    accepted.push(React.cloneElement(child, { key: i, ...child.props }))
  }

  return accepted
}

const onClickIcon = (props, e) => {
  if (typeof props.onPointerDown === 'function') {
    props.onPointerDown(e)
  }
}

const GlueButton = (props) => {
  const classes = useStyles(props)
  // const audiomessage = !!props.uiAudioMessage ? props.uiAudioMessage : "Menu/Generic/Button/Press"
  // const hoveraudiomessage = !!props.uiHoverAudioMessage ? props.uiHoverAudioMessage : "Menu/Generic/Button/HL"

  const children = filterChildren(props.children, classes)

  return (
    <ButtonBase className={classes.root} disabled={props.disabled}
      // onPointerDown={(e) => {onClickIcon(props,e); clickAudio(audiomessage)} }
      onPointerDown={e => onClickIcon(props, e)}
      // onPointerEnter={() => {hoverAudio(hoveraudiomessage)}}
      onClick={props.onClick}
    >
      {children}
    </ButtonBase>
  )
}

export default GlueButton
